import App from "./../app.jsx";

import Dashboard from "./../pages/dashboard/dashboard.js";

import PagesError from "./../pages/pages/error.js";

import MpDetail from "../pages/manpower/profile.jsx";

import Logingin from "../pages/logingin/login.js";

import AppLogin from "../appLogin.jsx";
import Kpi from "../pages/kpi/kpi.jsx";
import Data from "../pages/manpower/data.jsx";
import NewManpower from "../pages/manpower/new.jsx";
import EditManpower from "../pages/manpower/edit.jsx";
import DataTraining from "../pages/training/data.jsx";
import DetailTraining from "../pages/training/detail/detail.jsx";
import TrainingReport from "../pages/training/report.jsx";
import ReportEvent from "../pages/training/reportEvent.jsx";
import DataMentoring from "../pages/mentoring/data.jsx";
import DetailMentoring from "../pages/mentoring/detail.jsx";
import MentoringReport from "../pages/mentoring/report.jsx";
import MentorReportEvent from "../pages/mentoring/reportEvent.jsx";
import MentorReportDocument from "../pages/mentoring/reportDocument.jsx";
import TrainingPlanData from "../pages/trainingPlan/data.jsx";
import PlanTrainingDetail from "../pages/trainingPlan/detail.jsx";
import PlanTrainingNewReport from "../pages/trainingPlan/report.jsx";
import QuestionData from "../pages/question/data.jsx";
import QuestionDetail from "../pages/question/detail.jsx";
import EventData from "../pages/question/event.jsx";
import EventDetail from "../pages/question/eventDetail.jsx";
import EventResult from "../pages/question/eventResult.jsx";
import PagesLogin from "../pages/login/login.jsx";
import AppProtected from "../appProtected.jsx";
import Settings from "../pages/profile/settings.js";
import Logingout from "../pages/logout/logingout.js";
import RegulationSOPData from "../pages/regulations/data-SOP.jsx";
import ManpowerDashboard from "../pages/manpower/dashboard.jsx";
import TrainingEvaluationData from "../pages/training-evaluation/data.jsx";
import Tel1Detail from "../pages/training-evaluation/detail.jsx";
import TrainingDashboard from "../pages/training/dashboard/trainingDashboard.jsx";
import DataAtmp from "../pages/training/atmp/data.jsx";
import OtherActivity from "../pages/otherActivity/otherActivity.jsx";
import OtherActivityNew from "../pages/otherActivity/otherActivityNew.jsx";
import OtherActivityDetail from "../pages/otherActivity/otherActivityDetail.jsx";
import Tel3Event from "../pages/tel3/data/data.jsx";
import Tel3Detail from "../pages/tel3/detail/detail.jsx";
import NewRecordTel3 from "../pages/tel3/new/new.jsx";
import WhatsappOutgoing from "../pages/whatsapp/outgoing/outgoingList.jsx";
import NewRecordTel3FromOutstanding from "../pages/tel3/new/newFromOutstanding.jsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [{ path: "login", element: <PagesLogin /> }],
  },
  {
    path: "*",
    element: <AppProtected />,
    children: [
      { path: "", element: <Logingin /> },
      { path: "logingout", element: <Logingout /> },
      { path: "kpi", element: <Kpi /> },
      { path: "dashboard", element: <Dashboard /> },
      {
        path: "manpower/*",
        children: [
          { path: "data", element: <Data /> },
          { path: "detail/:id", element: <MpDetail /> },
          { path: "new", element: <NewManpower /> },
          { path: "edit/:id", element: <EditManpower /> },
          { path: "dashboard", element: <ManpowerDashboard /> },
        ],
      },
      {
        path: "training/*",
        children: [
          { path: "dashboard", element: <TrainingDashboard /> },
          { path: "data", element: <DataTraining /> },
          { path: "detail/:id", element: <DetailTraining /> },
          { path: "plan/data", element: <TrainingPlanData /> },
          { path: "plan/detail/:id", element: <PlanTrainingDetail /> },
          { path: "plan/new", element: <PlanTrainingNewReport /> },
          { path: "atmp", element: <DataAtmp /> },
          {
            path: "report/",
            element: <TrainingReport />,
            children: [{ path: "event", element: <ReportEvent /> }],
          },
        ],
      },
      {
        path: "mentoring/*",
        children: [
          { path: "data", element: <DataMentoring /> },
          { path: "detail/:id", element: <DetailMentoring /> },
          {
            path: "report/",
            element: <MentoringReport />,
            children: [
              { path: "event", element: <MentorReportEvent /> },
              { path: "document", element: <MentorReportDocument /> },
            ],
          },
        ],
      },
      {
        path: "other-activity/*",
        children: [
          { path: "data", element: <OtherActivity /> },
          { path: "new", element: <OtherActivityNew /> },
          { path: "detail/:id", element: <OtherActivityDetail /> },
        ],
      },
      {
        path: "question/*",
        children: [
          { path: "data", element: <QuestionData /> },
          { path: "event", element: <EventData /> },
          { path: "detail/:id", element: <QuestionDetail /> },
          { path: "event-detail/:id", element: <EventDetail /> },
          { path: "event-result/:id", element: <EventResult /> },
        ],
      },
      {
        path: "training-evaluation/*",
        children: [
          { path: "event", element: <TrainingEvaluationData /> },
          { path: "result-list/:id", element: <Tel1Detail /> },
        ],
      },
      {
        path: "training-evaluation-3/*",
        children: [
          { path: "data", element: <Tel3Event /> },
          { path: "detail/:id", element: <Tel3Detail /> },
          { path: "new", element: <NewRecordTel3 /> },
          { path: "new-from-outstanding/:id", element: <NewRecordTel3FromOutstanding /> },
        ],
      },
      {
        path: "regulations/*",
        children: [{ path: "sop", element: <RegulationSOPData /> }],
      },
      {
        path: "whatsapp/*",
        children: [{ path: "outgoing", element: <WhatsappOutgoing /> }],
      },
      {
        path: "profile/",
        children: [{ path: "setting", element: <Settings /> }],
      },
    ],
  },
  {
    path: "*",
    element: <AppLogin />,
    children: [{ path: "*", element: <PagesError /> }],
  },
];

export default AppRoute;
